/* eslint-disable */
import validator from 'validator';
import React from 'react';
import moment from 'moment';
import { getNZDateTime } from '../dateUtil';
import { dateConfig } from '../../configureApp';
export const optional = () => true;
export const required = (value) => {
  const newValue = value ? value.toString() : '';
  return !validator.isEmpty(newValue);
};
export const maxLength = (length) => {
  function mLength(value) {
    const newValue = value ? value.toString() : '';
    return newValue.toString().trim().length <= length;
  }

  return mLength;
};

export const minLength = (length) => {
  function miLength(value) {
    const newValue = value ? value.toString() : '';
    return newValue.toString().trim().length >= length;
  }

  return miLength;
};

export const validUSABankRoutingNumber = (bankCode) => {
  const regex = /^\d{9}$/;
  return regex.test(bankCode.trim()) && bankCode.trim().length === 9;
}

export const validEmail = (value) => {
  const newValue = value ? value.toString() : '';
  if(newValue === ''){
    return true;
  }

  if(!isValidEmail(newValue)){
    return false;
  }
  
  return true;
};
export const isValidEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
}
export const length = (len) => {
  function mLength(value) {
    const newValue = value ? value.toString() : '';
    return newValue.toString().trim().length === len;
  }

  return mLength;
};

export const maxAmountLength = (value) => {
  if (!value) return true;
  // Remove any commas and spaces from the value
  const cleanValue = value.toString().replace(/[,\s]/g, '');
  // Check if number matches pattern for max 12 digits (10 before decimal + 2 after)
  const regex = /^\d{1,10}(\.\d{0,2})?$/;
  return regex.test(cleanValue) && cleanValue.replace('.', '').length <= 12;
};

export const email = (value) => {
  if (!validator.isEmail(value)) {
    return `${value} is not a valid email.`;
  }
};

export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return (
      <span className="error">
        The value exceeded {props.maxLength} symbols.
      </span>
    );
  }
  return null;
};

export const checkEventDate = (eventTime) => {
  return function checkDate(eventDate) {
    let chosenDate = moment(eventDate);
    let todayDate = getNZDateTime();
    if (!eventTime) {
      return !chosenDate.isAfter(todayDate);
    } else {
      if (!chosenDate.isAfter(todayDate)) {
        return true;
      }
      const chosenDateTimeString = moment(eventDate).format('YYYY-MM-DD') + ' ' + moment(eventTime).format(dateConfig.timeString); 
      let chosenDateTime = moment(chosenDateTimeString);
      let todayDateTime = getNZDateTime();
      return !chosenDateTime.isAfter(todayDateTime);
    }
  };
};

export const checkDateOnly = (date) => {
  let chosenDate = moment(date);
  if (!chosenDate) {
    return false;
  } 
  const currentNZDate = getNZDateTime();
  return !chosenDate.isAfter(currentNZDate.format('YYYY-MM-DD'));
};

// Fight Aware API
export const checkFlightDateOnly = (date) => {
  let chosenDate = moment(date);
  if (!chosenDate.isValid()) {
    return false;
  }

  const oneYearAgo = moment().subtract(1, 'years');
  const today = moment().add(1, 'years');

  // Flight dates should be within the last year up to today
  return chosenDate.isBetween(oneYearAgo, today, 'day', '[]');
};

export const checkFlightNumberOnly = (flightNumber) => {
  // Regex to validate 2 letters followed by 1–4 digits
  const flightNumberRegex = /^[A-Za-z]{2}\d{1,4}$/;

  // Check if the flight number matches the regex
  if (!flightNumberRegex.test(flightNumber)) {
    return false;
  }

  return true;
};

export const checkEventTime = (eventDate) => {
  return function checkTime(eventTime) {
    if (!eventDate) {
      return true;
    } else {
      const chosenDateTimeString = moment(eventDate).format('YYYY-MM-DD') + ' ' + moment(eventTime).format(dateConfig.timeString); 
      let chosenDateTime = moment(chosenDateTimeString);
      let todayDateTime = getNZDateTime();
      return !chosenDateTime.isAfter(todayDateTime);
    }
  };
};

export const password = (value, props, components) => {
  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (value !== components.confirm[0].value) {
    // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return <span className="error">Passwords are not equal.</span>;
  }
  return null;
}; 

export const alphaHyphenOnly = (value) => {
  if (!value) return true;
  return /^[a-zA-Z\s-]+$/.test(value.toString().trim());
};



// WEBPACK FOOTER //
// ./app/utils/validation/validator.js